import normalMode from "../../normalMode";
import {RegisterSpecialEventEntity} from "../../manager/NormalGameManager";
import {EventParamsTypeConstant} from "../const/EventParamsTypeConstant";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

/**
 * 特殊 事件展示
 */
@ccclass
export default class SpecialEventShow extends cc.Component {

    @property(cc.Label)
    lbDesc : cc.Label = null;
    @property(cc.Label)
    lbTitle : cc.Label = null;
    @property(cc.Node)
    chooseOption1 : cc.Node = null;
    @property(cc.Node)
    chooseOption2 : cc.Node = null;

    @property(cc.Node)
    userNode : cc.Node = null;
    @property(cc.Node)
    hourNode : cc.Node = null;
    @property(cc.Node)
    strongerNode : cc.Node = null;
    @property(cc.Node)
    moodNode : cc.Node = null;
    @property(cc.Node)
    healthNode : cc.Node = null;
    @property(cc.Node)
    moneyNode : cc.Node = null;

    @property(cc.Node)
    center : cc.Node = null;

    private mParentScript : normalMode ;
    private mEventEntity : RegisterSpecialEventEntity;

    private hour : number = 0;
    private stronger : number = 0;
    onLoad () {
        this.center.scale = 0.1;
        cc.tween(this.center).to(.5,{scale:1},{ easing:cc.easing.backOut }).start();
    }

    start () {
    }

    bindData( eventEntity : RegisterSpecialEventEntity , gameLayer : normalMode  ){
        this.mEventEntity = eventEntity;
        this.mParentScript = gameLayer;

        // if( eventEntity.effectParams && eventEntity.effectParams.length != 0 ) {
        //     // this.userNode.active = true;
        //     // 消耗体力值以及时间
        //     for ( let effectParam of eventEntity.effectParams ) {
        //         switch ( effectParam.key ) {
        //             // case EventParamsTypeConstant.HOUR:
        //             //     this.hour = effectParam.value;
        //             //     // this.hourNode.active = true;
        //             //     // let hourTemp : string ;
        //             //     // if ( effectParam.value > 0 ) {
        //             //     //     hourTemp = `+${effectParam.value}小时`;
        //             //     //     this.hourNode.getChildByName("lbHour").color = cc.color( 229 , 109 , 109 );
        //             //     // }else{
        //             //     //     hourTemp = `-${effectParam.value}小时`;
        //             //     //     this.hourNode.getChildByName("lbHour").color = cc.color( 113 , 210 , 110 );
        //             //     // }
        //             //     // this.hourNode.getChildByName("lbHour").getComponent(cc.Label).string = hourTemp;
        //             //     break;
        //             // case EventParamsTypeConstant.STRONGER:
        //             //     this.stronger = effectParam.value;
        //             //     this.strongerNode.active = true;
        //             //     let strongerTemp : string;
        //             //     if ( effectParam.value > 0 ) {
        //             //         strongerTemp = `+${effectParam.value}`;
        //             //         this.strongerNode.getChildByName("lbStronger").color = cc.color( 113 , 210 , 110 );
        //             //     }else{
        //             //         strongerTemp = `${effectParam.value}`;
        //             //         this.strongerNode.getChildByName("lbStronger").color = cc.color( 229 , 109 , 109 );
        //             //     }
        //             //     this.strongerNode.getChildByName("lbStronger").getComponent(cc.Label).string = strongerTemp;
        //             //     break;
        //             // case EventParamsTypeConstant.MOOD:
        //             //     this.moodNode.active = true;
        //             //     let moodTemp : string;
        //             //     if ( effectParam.value > 0 ) {
        //             //         moodTemp = `+${effectParam.value}`;
        //             //         this.moodNode.getChildByName("lbMood").color = cc.color( 113 , 210 , 110 );
        //             //     }else{
        //             //         moodTemp = `${effectParam.value}`;
        //             //         this.moodNode.getChildByName("lbMood").color = cc.color( 229 , 109 , 109 );
        //             //     }
        //             //     this.moodNode.getChildByName("lbMood").getComponent(cc.Label).string = moodTemp;
        //             //     break;
        //             // case EventParamsTypeConstant.HEALTH:
        //             //     this.healthNode.active = true;
        //             //     let healthTemp : string;
        //             //     if ( effectParam.value > 0 ) {
        //             //         healthTemp = `+${effectParam.value}`;
        //             //         this.healthNode.getChildByName("lbHealth").color = cc.color( 113 , 210 , 110 );
        //             //     }else{
        //             //         healthTemp = `${effectParam.value}`;
        //             //         this.healthNode.getChildByName("lbHealth").color = cc.color( 229 , 109 , 109 );
        //             //     }
        //             //     this.healthNode.getChildByName("lbHealth").getComponent(cc.Label).string = healthTemp;
        //             //     break;
        //             case EventParamsTypeConstant.MONEY:
        //                 this.moneyNode.active = true;
        //                 let moneyTemp : string;
        //                 if ( effectParam.value > 0 ) {
        //                     moneyTemp = `+${effectParam.value}`;
        //                     this.moneyNode.getChildByName("lbMoney").color = cc.color( 113 , 210 , 110 );
        //                 }else{
        //                     moneyTemp = `${effectParam.value}`;
        //                     this.moneyNode.getChildByName("lbMoney").color = cc.color( 229 , 109 , 109 );
        //                 }
        //                 this.moneyNode.getChildByName("lbMoney").getComponent(cc.Label).string = moneyTemp;
        //                 break;
        //         }
        //     }
        //
        // }

        // this.mParentScript.btnSkipNode.active = false;
        this.lbDesc.string = `${this.mEventEntity.desc}`;
        this.chooseOption1.active = true;
        if ( eventEntity.chooseArray ) {
            this.lbTitle.string = `突发事件`;
            //有后续事件的
            this.chooseOption2.active = true;
            this.chooseOption1.getChildByName("lbName").getComponent(cc.Label).string = `${this.mEventEntity.chooseArray[0].chooseItemName}`;
            this.chooseOption2.getChildByName("lbName").getComponent(cc.Label).string = `${this.mEventEntity.chooseArray[1].chooseItemName}`;
        }else{
            this.lbTitle.string = `事件结果`;
            this.chooseOption1.getChildByName("lbName").getComponent(cc.Label).string = `知道了`;
        }
    }

    /**
     * 选择
     * @param e
     * @param define
     */
    async onBtnChoose( e , define : string){
        switch( define ){
            case "1":
                if ( this.mEventEntity.chooseArray )  {
                    //选择1
                    let itemEntity : RegisterSpecialEventEntity = {
                        startHours : 0,
                        waitHours : 0,
                        type : 1,
                        desc : this.mEventEntity.chooseArray[0].desc,
                        effectParams : this.mEventEntity.chooseArray[0].effectParams
                    };
                    cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
                        this.mParentScript.setEventShow( itemEntity );
                        this.node.destroy();
                        this.node.removeFromParent();
                    }).start();
                }else{
                    //知道了
                    if ( this.stronger != 0 || this.hour != 0 ) {
                        O1HD.emit("NormalGameManager.consumption" , this.stronger < 0 ? Math.abs( this.stronger ) : 0 , this.hour );
                    }
                    // 处理事件对应影响的参数
                    this.mParentScript.gameManager.effectParamsDealWith( this.mEventEntity.effectParams );
                    //展示下一个事件
                    this.mParentScript.specialEventShow();
                    cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
                        // this.mParentScript.btnSkipNode.active = true;
                        this.node.destroy();
                        this.node.removeFromParent();
                    }).start();
                }
                break;
            case "2":
                let itemEntity2 : RegisterSpecialEventEntity = {
                    startHours : 0,
                    waitHours : 0,
                    type : 1,
                    desc : this.mEventEntity.chooseArray[1].desc,
                    effectParams : this.mEventEntity.chooseArray[1].effectParams
                };
                cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
                    this.mParentScript.setEventShow( itemEntity2 );
                    this.node.destroy();
                    this.node.removeFromParent();
                }).start();
                break;
        }


    }


}
